export const getCurrentScreen = (state: any) => state.screen
export const getCurrentQuestion = (state: any) => getCurrentScreen(state).get('child');
export const getCurrentQuestionCode = (state: any) => getCurrentQuestion(state).getIn(['parent','code']);